const encode = bytes => btoa(String.fromCharCode(...bytes)).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
export async function encryptSecret(password) {
  if (!window.crypto?.subtle) throw new Error('Le partage chiffré nécessite une connexion HTTPS et un navigateur récent.');
  const key = await window.crypto.subtle.generateKey({name:'AES-GCM',length:256},true,['encrypt']);
  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const ciphertext = await window.crypto.subtle.encrypt({name:'AES-GCM',iv},key,new TextEncoder().encode(password));
  const rawKey = await window.crypto.subtle.exportKey('raw',key);
  return {envelope:{version:1,iv:encode(iv),ciphertext:encode(new Uint8Array(ciphertext))},key:encode(new Uint8Array(rawKey))};
}
export function secretLink(id, key) {
  if (!/^[a-f0-9]{48}$/.test(id) || !/^[A-Za-z0-9_-]{43}$/.test(key)) throw new Error('Lien de partage invalide.');
  return 'https://fortisecure.fr/secret/#' + id + '.' + key;
}
